const runtimeEnv = (typeof globalThis !== 'undefined' && globalThis.__ENV__) || {};
const getEnv = (key, fallback = '') => runtimeEnv[key] ?? import.meta.env?.[`VITE_${key}`] ?? fallback;
const getBooleanEnv = (key, fallback = false) => {
	const value = getEnv(key);
	return value === '' ? fallback : String(value).toLowerCase() === 'true';
};

export const API_HOST = `${getEnv('API_HOST')}`;
export const GEOCODER_HOST = `${getEnv('GEOCODER_HOST')}`;
export const GEOCODER_CLIENT_ID = `${getEnv('GEOCODER_CLIENT_ID')}`;
export const ROUTER_URL = `${getEnv('ROUTER_URL', 'https://router.api.gov.bc.ca/route.json')}`;
export const ROUTER_CLIENT_ID = `${getEnv('ROUTER_CLIENT_ID')}`;
export const DEBUG = `${getEnv('DEBUG')}`;
export const BASE_MAP_URL = `${getEnv('BASE_MAP_URL')}`;
export const MAP_STYLE_URL = `${getEnv('MAP_STYLE_URL')}`;
export const DEPLOYMENT_TAG = `${getEnv('DEPLOYMENT_TAG')}`;
export const BRANCH = `${getEnv('BRANCH')}`;
export const RELEASE = `${getEnv('RELEASE')}`;
export const SHOW_DEBUG_CONTROL = getBooleanEnv('SHOW_DEBUG_CONTROL');
export const ALLOW_LOCAL_ACCOUNTS = `${getEnv('ALLOW_LOCAL_ACCOUNTS')}`;
export const EVENT_POLLING_REFRESH = `${getEnv('EVENT_POLLING_REFRESH')}`;
export const DMS_API_URL = `${getEnv('DMS_API_URL')}`;
export const CLEARING_TIMEOUT = parseInt(`${getEnv('CLEARING_TIMEOUT', 900000)}`);
export const ENVIRONMENT = `${getEnv('ENVIRONMENT')}`;
// set to true to remove geometries from service areas so that data is small
// enough for redux-devtools to work with the store
export const ELIDE_SERVICE_AREA_GEOMETRIES = `${getEnv('ELIDE_SERVICE_AREA_GEOMETRIES')}`;
export const ROUTABLE_LOCATIONS_HOST = `${getEnv('ROUTABLE_LOCATIONS_HOST', '')}`;
